import { render, staticRenderFns } from "./waiting-queue.vue?vue&type=template&id=f6038a7e&scoped=true"
import script from "./waiting-queue.ts?vue&type=script&lang=ts&external"
export * from "./waiting-queue.ts?vue&type=script&lang=ts&external"
import style0 from "./waiting-queue.scss?vue&type=style&index=0&id=f6038a7e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6038a7e",
  null
  
)

export default component.exports